import { __makeTemplateObject } from "tslib";
import { css, px, spacing } from '../../../../foundation';
import { RcDivider } from '../../../Divider';
export var DividerInMenuStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    margin: ", ";\n  }\n"], ["\n  ", " {\n    margin: ", ";\n  }\n"])), RcDivider, spacing(2, 0));
export var MenuListStyle = function (_a) {
    var maxHeight = _a.maxHeight;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    overflow: auto;\n    max-height: ", ";\n    ", ";\n  "], ["\n    overflow: auto;\n    max-height: ", ";\n    ", ";\n  "])), maxHeight && px(maxHeight), DividerInMenuStyle);
};
var templateObject_1, templateObject_2;
